import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  effect,
  inject,
  input,
  output,
  viewChild
} from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { Dropdown } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MeasureStatusDTO } from 'csr-asset-app';
import { MeasureStatusActionButton } from './measure-status-action-button';

@Component({
  selector: 'cfp-measure-status-action-dropdown',
  templateUrl: './measure-status-action-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dropdown, MeasureStatusActionButton, TranslateModule]
})
export class MeasureStatusActionDropdown {
  public readonly measure = input.required<any>();

  public readonly saveStatus = output<{ measure: any; newStatus: MeasureStatusDTO }>();
  protected readonly closed = output<void>();
  protected readonly MeasureStatusDTO = MeasureStatusDTO;

  private readonly environment = inject(ENVIRONMENT);

  private dropdown = viewChild(Dropdown);

  protected hideDoneMeasuresAndStatus = this.environment.components?.hideDoneMeasuresAndStatus === true;

  private readonly dropdownContent = viewChild<ElementRef<HTMLElement>>('dropdownContent');

  private readonly _ = effect(() => {
    const dropdownElement = this.dropdownContent()?.nativeElement;
    if (!dropdownElement) {
      return;
    }

    const status = this.measure().status;
    setTimeout(() => {
      const selected = dropdownElement.querySelector<HTMLElement>(`button[value="${status}"]`);
      const target = selected ?? dropdownElement.querySelector<HTMLElement>('button');
      target?.focus({ preventScroll: true });
    });
  });

  protected onSaveStatus(newStatus: MeasureStatusDTO): void {
    this.dropdown()?.hide();
    this.saveStatus.emit({ measure: this.measure(), newStatus: newStatus });
  }
}
